import { PhoneBookEntry } from '../types';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { displayPhone, normalizePhone } from '../utils/phone';
import { useNavigate } from 'react-router-dom';

interface CallButtonProps {
  contact: PhoneBookEntry;
  size?: 'sm' | 'md' | 'lg';
}

export const CallButton = ({ contact, size = 'md' }: CallButtonProps) => {
  const { user, profile } = useAuth();
  const navigate = useNavigate();

  const normalized = normalizePhone(contact.phone_number);
  const padding = size === 'sm' ? 'px-2 py-1 text-xs' : size === 'lg' ? 'px-4 py-2 text-base' : 'px-3 py-1.5 text-sm';

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!user) {
      navigate('/login');
      return;
    }
    try {
      await supabase.from('contact_view_audit').insert({
        viewer_user_id: user.id,
        viewer_name: profile?.full_name ?? null,
        viewer_mobile: profile?.phone ?? null,
        contact_id: contact.id,
        contact_name: contact.name,
        contact_mobile: contact.phone_number,
      });
    } catch {
      // ignore audit failures
    }
    window.location.href = `tel:${normalized}`;
  };

  return (
    <a
      href={!user ? '/login' : `tel:${normalized}`}
      onClick={handleClick}
      className={`inline-flex items-center gap-1 rounded-full bg-green-600 font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${padding}`}
      aria-label={`Call ${displayPhone(contact.phone_number)}`}
    >
      <span aria-hidden="true">📞</span>
      <span>Call</span>
    </a>
  );
};
